import { render, staticRenderFns } from "./RelAnalitico.vue?vue&type=template&id=9c020ba2&scoped=true"
import script from "./RelAnalitico.vue?vue&type=script&lang=js"
export * from "./RelAnalitico.vue?vue&type=script&lang=js"
import style0 from "./RelAnalitico.vue?vue&type=style&index=0&id=9c020ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c020ba2",
  null
  
)

export default component.exports